module.exports = __webpack_public_path__ + "static/artisticbanner.4041436a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/artisticbanner.jpg
// module id = 1493
// module chunks = 256810187883326